import React from 'react';
import {motion} from 'framer-motion';
import {FiPhone,FiMail,FiMapPin,FiClock,FiMessageSquare,FiExternalLink} from 'react-icons/fi';

const ContactPage=()=> {
  const contactInfo=[ 
    {
      icon: <FiPhone className="text-blue-600" size={24} />,
      title: "Phone",
      details: "(870) 208-4089",
      description: "Mon-Fri 9:00 AM - 5:00 PM"
    },
    {
      icon: <FiMail className="text-blue-600" size={24} />,
      title: "Email",
      details: "snows.tax.financial@gmail.com",
      description: "For tax services & general inquiries"
    },
    {
      icon: <FiMapPin className="text-blue-600" size={24} />,
      title: "Address",
      details: "144 Linwood Drive",
      description: "Paragould,AR 72450"
    },
    {
      icon: <FiClock className="text-blue-600" size={24} />,
      title: "Business Hours",
      details: "Monday - Friday",
      description: "9:00 AM - 5:00 PM"
    } 
  ];

  return ( 
    <> 
      <section className="pt-32 pb-16 bg-blue-800 text-white"> 
        <div className="container mx-auto px-4"> 
          <motion.div 
            initial={{opacity: 0,y: 30}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8}} 
            className="max-w-4xl mx-auto text-center" 
          > 
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1> 
            <p className="text-xl">We're here to help with all your tax and financial needs. Reach out today!</p> 
          </motion.div> 
        </div> 
      </section> 
      
      <section className="py-20 bg-white"> 
        <div className="container mx-auto px-4"> 
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16"> 
            {contactInfo.map((info,index)=> ( 
              <motion.div 
                key={index} 
                initial={{opacity: 0,y: 30}} 
                whileInView={{opacity: 1,y: 0}} 
                viewport={{once: true}} 
                transition={{duration: 0.6,delay: index * 0.1}} 
                className="bg-gray-50 p-6 rounded-lg shadow-md text-center" 
              > 
                <div className="flex justify-center mb-4"> 
                  {info.icon} 
                </div> 
                <h3 className="text-xl font-semibold mb-2">{info.title}</h3> 
                <p className="font-medium mb-1">{info.details}</p> 
                <p className="text-gray-600 text-sm">{info.description}</p> 
              </motion.div> 
            ))} 
          </div> 
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12"> 
            <motion.div 
              initial={{opacity: 0,x: -30}} 
              whileInView={{opacity: 1,x: 0}} 
              viewport={{once: true}} 
              transition={{duration: 0.8}} 
            > 
              <h2 className="text-3xl font-bold mb-6">Get In Touch</h2> 
              <p className="text-gray-700 mb-6"> 
                Have a question? Send us an email. We usually reply in 1-2 business days. If you need to reach us sooner,please call the office at <a href="tel:870-208-4089" className="text-blue-600 font-semibold">(870) 208-4089</a>. 
                <br /><br /> 
                You can directly email us at: 
              </p> 
              
              <ul className="space-y-4 mb-8"> 
                <li className="flex items-center"> 
                  <FiMail className="text-blue-600 mr-3" /> 
                  <div> 
                    <p className="font-semibold">For Wealth Management:</p> 
                    <a href="mailto:SimeonSnow@afpadvisor.com" className="text-blue-600 hover:underline">SimeonSnow@afpadvisor.com</a> 
                  </div> 
                </li> 
                <li className="flex items-center"> 
                  <FiMail className="text-blue-600 mr-3" /> 
                  <div> 
                    <p className="font-semibold">For Tax Services & General Inquiries:</p> 
                    <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600 hover:underline">snows.tax.financial@gmail.com</a> 
                  </div> 
                </li> 
              </ul> 
              
              <div className="bg-gray-50 p-6 rounded-lg shadow-md mb-8"> 
                <div className="flex items-center mb-4"> 
                  <FiMessageSquare className="text-blue-600 mr-3" size={24} /> 
                  <h3 className="text-xl font-semibold">Chat with Tax Genie</h3> 
                </div> 
                <p className="text-gray-700 mb-4"> 
                  Our AI assistant can help answer your tax questions,provide information about our services,and more. 
                </p> 
                <a 
                  href="https://chat.cxgenie.ai?aid=aa497be5-90c3-4915-bf01-aa186a491191&lang=en" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center" 
                > 
                  <span>Start Chat</span> 
                  <FiExternalLink className="ml-2" /> 
                </a> 
              </div> 
              
              <div className="bg-gray-50 p-6 rounded-lg shadow-md"> 
                <div className="flex items-center mb-4"> 
                  <FiClock className="text-blue-600 mr-3" size={24} /> 
                  <h3 className="text-xl font-semibold">Schedule Appointment</h3> 
                </div> 
                <p className="text-gray-700 mb-4"> 
                  Ready to meet with our team? Schedule an appointment at your convenience. 
                </p> 
                <a 
                  href="https://lunacal.ai/simeon-snow" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center" 
                > 
                  <span>Book Now</span> 
                  <FiExternalLink className="ml-2" /> 
                </a> 
              </div> 
            </motion.div> 
            
            <motion.div 
              initial={{opacity: 0,x: 30}} 
              whileInView={{opacity: 1,x: 0}} 
              viewport={{once: true}} 
              transition={{duration: 0.8}} 
              className="h-full min-h-[500px]" 
            > 
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3255.2857276630023!2d-90.50772548473951!3d36.055481680106894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d1d04d4e0142df%3A0x8e9acb99d5e3416a!2s144%20Linwood%20Dr%2C%20Paragould%2C%20AR%2072450!5e0!3m2!1sen!2sus!4v1659450000000!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{border: 0,borderRadius: "0.5rem"}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade" 
                title="Snow's Tax & Financial Location" 
              ></iframe> 
            </motion.div> 
          </div> 
        </div> 
      </section> 
      
      <section className="py-20 bg-gray-50"> 
        <div className="container mx-auto px-4"> 
          <div className="max-w-4xl mx-auto text-center"> 
            <motion.div 
              initial={{opacity: 0,y: 30}} 
              whileInView={{opacity: 1,y: 0}} 
              viewport={{once: true}} 
              transition={{duration: 0.8}} 
            > 
              <h2 className="text-3xl font-bold mb-6">Our Process</h2> 
              <p className="text-lg text-gray-700 mb-12"> 
                We make working with us simple and straightforward. Here's what you can expect: 
              </p> 
              
              <div className="flex flex-col md:flex-row gap-8 text-left"> 
                {[ 
                  {
                    step: "1",
                    title: "Initial Consultation",
                    description: "We'll discuss your financial situation,goals,and concerns."
                  },
                  {
                    step: "2",
                    title: "Customized Plan",
                    description: "We'll develop a personalized strategy tailored to your specific needs."
                  },
                  {
                    step: "3",
                    title: "Implementation",
                    description: "We'll put your plan into action and provide ongoing support."
                  } 
                ].map((item,index)=> ( 
                  <div key={index} className="flex-1 bg-white p-6 rounded-lg shadow-md"> 
                    <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mb-4"> 
                      {item.step} 
                    </div> 
                    <h3 className="text-xl font-semibold mb-2">{item.title}</h3> 
                    <p className="text-gray-700">{item.description}</p> 
                  </div> 
                ))} 
              </div> 
            </motion.div> 
          </div> 
        </div> 
      </section> 
    </> 
  );
};

export default ContactPage;